<template>
  <div>
    <div v-if="desactivado !== true" @click="click" class="block text-left ml-6 border-t border-gray-500 first:border-t-0 p-1">
      <router-link :to="to" class="w-full" tag="button"> 
        <div class="text-left text-white text-base">{{ titulo }}</div>
        <div class="text-left text-teal-300 text-xs">
          {{ descripcion }}
        </div>
      </router-link>
    </div>

    <div v-if="desactivado === true" class="block text-left ml-6 border-t border-gray-500 first:border-t-0 p-1">
      <div class="w-full" tag="button">
        <div class="text-left text-teal-400 text-base">{{ titulo }}</div>
        <div class="text-left text-teal-400 text-xs">
          {{ descripcion }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["titulo", "descripcion", "to", "desactivado"],
  methods: {
    click() {
      this.$emit("clickeado", this.numero);
    }
  }
};
</script>
